__turbopack_context__.v({
  "activeFilter": "add-to-scene-module__D6KdPa__activeFilter",
  "addButton": "add-to-scene-module__D6KdPa__addButton",
  "addToSceneButton": "add-to-scene-module__D6KdPa__addToSceneButton",
  "assetCard": "add-to-scene-module__D6KdPa__assetCard",
  "assetImage": "add-to-scene-module__D6KdPa__assetImage",
  "assetInfo": "add-to-scene-module__D6KdPa__assetInfo",
  "assetName": "add-to-scene-module__D6KdPa__assetName",
  "assetPrice": "add-to-scene-module__D6KdPa__assetPrice",
  "audioCard": "add-to-scene-module__D6KdPa__audioCard" + " " + "add-to-scene-module__D6KdPa__assetCard",
  "audioDuration": "add-to-scene-module__D6KdPa__audioDuration",
  "audioIcon": "add-to-scene-module__D6KdPa__audioIcon",
  "audioInfo": "add-to-scene-module__D6KdPa__audioInfo",
  "audioName": "add-to-scene-module__D6KdPa__audioName",
  "audioThumbnail": "add-to-scene-module__D6KdPa__audioThumbnail",
  "buttonPress": "add-to-scene-module__D6KdPa__buttonPress",
  "cardButton": "add-to-scene-module__D6KdPa__cardButton",
  "cardContent": "add-to-scene-module__D6KdPa__cardContent",
  "cardImage": "add-to-scene-module__D6KdPa__cardImage",
  "cardInfo": "add-to-scene-module__D6KdPa__cardInfo",
  "cardTitle": "add-to-scene-module__D6KdPa__cardTitle",
  "categoryActive": "add-to-scene-module__D6KdPa__categoryActive",
  "categoryButton": "add-to-scene-module__D6KdPa__categoryButton",
  "contentGrid": "add-to-scene-module__D6KdPa__contentGrid",
  "contentWrapper": "add-to-scene-module__D6KdPa__contentWrapper",
  "darkTheme": "add-to-scene-module__D6KdPa__darkTheme",
  "dragging": "add-to-scene-module__D6KdPa__dragging",
  "emptyContent": "add-to-scene-module__D6KdPa__emptyContent",
  "emptyInventory": "add-to-scene-module__D6KdPa__emptyInventory",
  "emptyInventoryActions": "add-to-scene-module__D6KdPa__emptyInventoryActions",
  "emptyInventoryContent": "add-to-scene-module__D6KdPa__emptyInventoryContent",
  "emptyInventoryIcon": "add-to-scene-module__D6KdPa__emptyInventoryIcon",
  "filterButton": "add-to-scene-module__D6KdPa__filterButton",
  "gridContainer": "add-to-scene-module__D6KdPa__gridContainer",
  "helpUpload": "add-to-scene-module__D6KdPa__helpUpload",
  "infoSection": "add-to-scene-module__D6KdPa__infoSection",
  "initialPointContent": "add-to-scene-module__D6KdPa__initialPointContent",
  "libraryItem": "add-to-scene-module__D6KdPa__libraryItem",
  "libraryItemName": "add-to-scene-module__D6KdPa__libraryItemName",
  "libraryTabs": "add-to-scene-module__D6KdPa__libraryTabs",
  "libraryThumbnail": "add-to-scene-module__D6KdPa__libraryThumbnail",
  "libraryThumbnailImg": "add-to-scene-module__D6KdPa__libraryThumbnailImg",
  "mainContent": "add-to-scene-module__D6KdPa__mainContent",
  "minimizedBar": "add-to-scene-module__D6KdPa__minimizedBar",
  "modalContainer": "add-to-scene-module__D6KdPa__modalContainer",
  "modalContent": "add-to-scene-module__D6KdPa__modalContent",
  "modalHeader": "add-to-scene-module__D6KdPa__modalHeader",
  "modalHeaderBtn": "add-to-scene-module__D6KdPa__modalHeaderBtn",
  "modalHeaderBtns": "add-to-scene-module__D6KdPa__modalHeaderBtns",
  "modalRoot": "add-to-scene-module__D6KdPa__modalRoot",
  "modalTitle": "add-to-scene-module__D6KdPa__modalTitle",
  "modalTitleContainer": "add-to-scene-module__D6KdPa__modalTitleContainer",
  "previewIcon": "add-to-scene-module__D6KdPa__previewIcon",
  "resizeHandle": "add-to-scene-module__D6KdPa__resizeHandle",
  "searchInput": "add-to-scene-module__D6KdPa__searchInput",
  "sectionTitle": "add-to-scene-module__D6KdPa__sectionTitle",
  "selected": "add-to-scene-module__D6KdPa__selected",
  "sidebar": "add-to-scene-module__D6KdPa__sidebar",
  "sidebarMenu": "add-to-scene-module__D6KdPa__sidebarMenu",
  "streamContent": "add-to-scene-module__D6KdPa__streamContent",
  "streamTab": "add-to-scene-module__D6KdPa__streamTab",
  "topSection": "add-to-scene-module__D6KdPa__topSection",
  "uploadButton": "add-to-scene-module__D6KdPa__uploadButton",
  "uploadContent": "add-to-scene-module__D6KdPa__uploadContent",
  "uploadWrapper": "add-to-scene-module__D6KdPa__uploadWrapper",
  "worldCard": "add-to-scene-module__D6KdPa__worldCard",
  "worldsGrid": "add-to-scene-module__D6KdPa__worldsGrid",
});
